import _ from "lodash";
import { FOLDER_MAP } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        folderMap: _.cloneDeep(constants.FOLDER_MAP_INPUT)
    }
}

const folderMapReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FOLDER_MAP.SET_FOLDER_MAP_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case FOLDER_MAP.SET_FOLDER_MAP:
        case FOLDER_MAP.SET_FOLDER_MAP_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    folderMap: action.folderMap
                }
            })
        default:
            return state
    }
}

export default folderMapReducer